import React from 'react';
import { DetailsContainer } from '../../containers';

const DetailsPage = () => <DetailsContainer />;

export default DetailsPage;
